import React, { Component, createRef } from 'react';
import { connect } from 'shalala';
import Validator from 'validatorjs';
import * as qs from 'query-string';
import { Guardian } from '@xaamin/guardian';
import { Row, Col, Button } from 'react-bootstrap';

import './Comprobantes.css';

import { Http } from '../../support';
import { useStore } from '../../store';
import ComprobantePago from './create/ComprobantePago';
import ComprobanteNomina from './create/ComprobanteNomina';
import FormaPagoCatalog from './support/catalogs/FormaPago';
import Backdrop from '../../facturotopia/backdrop/Backdrop';
import TipoComprobante from './support/enum/TipoComprobante';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import ResponseError from '../../shared/responses/ResponseError';
import EmisorSelection from './create/components/EmisorSelection';
import PersonalizarPdf from './create/components/PersonalizarPdf';
import ResponseResult from '../../shared/responses/ResponseResult';
import ComprobanteBaseRules from './validation/ComprobanteBaseRules';
import InformacionGlobal from './create/components/InformacionGlobal';
import ReceptorSelection from './create/components/ReceptorSelection';
import PrefacturaUpsert from '../prefacturas/upsert/PrefacturaUpsert';
import ComprobanteIngresoEgreso from './create/ComprobanteIngresoEgreso';
import DecimalForConceptos from './support/impuestos/DecimalForConceptos';
// import ComprobanteCreateContainer from './state/ComprobanteCreateContainer';
import PersonalizarDecimales from './create/components/PersonalizarDecimales';
import PersonalizarSucursalForm from './create/components/PersonalizarSucursalForm';
import CfdisRelacionadosManager from './create/components/CfdisRelacionadosManager';
import PersonalizarFechaEmision from './create/components/PersonalizarFechaEmision';
import PersonalizarObservaciones from './create/components/PersonalizarObservaciones';
import PersonalizarSerieFolioForm from './create/components/PersonalizarSerieFolioForm';
import UsePrefacturaBaseInputForm from './create/components/UsePrefacturaBaseInputForm';
import ComprobanteSelectionToolbar from './create/components/ComprobanteSelectionToolbar';
import ComprobanteCreationGlobalInfo from './create/components/ComprobanteCreationGlobalInfo';
import UsePreviousCfdiAsBaseInputForm from './create/components/UsePreviousCfdiAsBaseInputForm';
import ComprobanteRequestInputTransformer from './transformers/ComprobanteRequestInputTransformer';
import ComprobantesCreateSectorPrimarioToggle from './create/components/ComprobantesCreateSectorPrimarioToggle';

const steps = {
  bootstrap: false,
  tipo: false,
  info: false,
  cfdis_relacionados: false,
  emisor: false,
  receptor: false,
  conceptos: false,
  nomina: true,
};
class ComprobanteCreate extends Component {
  state = {};

  // Enum
  comprobante = null;

  constructor(props) {
    super(props);

    this.comprobante = TipoComprobante.undefined();

    this.state = {
      complemento: null,
      validator: new Validator({}, this.rules),
      receptorManualInfo: false,
      fechaRef: createRef(),
      tipoDeComprobanteRef: createRef(),
      metodoPagoRef: createRef(),
      formaPagoRef: createRef(),
      condicionesDePagoRef: createRef(),
      steps: { ...steps },
      showPagosForm: true,
    };
  }

  componentDidMount() {
    const { data } = this.props.create;

    const query = qs.parse(this.props.location.search);

    const TipoDeComprobante =
      !!query.t && !!TipoComprobante.search(query.t) ? TipoComprobante.search(query.t).getName() : null;

    let proxyTipoDeComprobante = TipoDeComprobante || data.TipoDeComprobante;

    this.comprobante = TipoComprobante.isValid(proxyTipoDeComprobante)
      ? TipoComprobante.make(proxyTipoDeComprobante)
      : TipoComprobante.undefined();

    this.setState(
      {
        ...this.state,
        steps: {
          ...this.state.steps,
          tipo: !!TipoDeComprobante,
        },
        complemento: this.comprobante.isPago() ? 'pago' : null,
      },
      () => {
        this.handleOnTipoDeComprobanteChange(this.comprobante.getName());
      }
    );
  }

  componentWillUnmount() {
    this.props.createActions.reset();

    DecimalForConceptos.decimales = 2;
  }

  rules(data) {
    let baseRules = ComprobanteBaseRules;

    let rules = baseRules(this.comprobante.getValue(), data);

    if (this.comprobante.isPago()) {
      rules.Complemento = {
        Pagos: {
          Pago: ['required', 'array', 'min:1'],
        },
      };
    }

    return rules;
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnSectorPrimarioChange = (value) => this.onChange(value, {});

  handleOnPagoChange = (value, showPagosForm = true) => {
    this.onChange(value);

    if (this.state.showPagosForm !== showPagosForm) {
      this.setState({
        ...this.state,
        showPagosForm: showPagosForm,
      });
    }

    setTimeout(() => {
      this.handleOnSetComplemento(null);
    }, 100);
  };

  onChange = (value, newSteps = {}) => {
    const { Metadata = {} } = this.props.create.data;

    if (value.MetodoPago) {
      value = {
        ...value,
        FormaPago: value.MetodoPago === 'PPD' ? '99' : value.FormaPago !== 'P01' ? value.FormaPago : '',
      };
    }

    if (value.InformacionGlobal?.periodicidad === '05') {
      let newInformacionGlobal = value.InformacionGlobal;

      const bimestral = ['13', '14', '15', '16', '17', '18'];

      if (bimestral.indexOf(value.InformacionGlobal?.meses) === -1) {
        newInformacionGlobal = {
          ...value.InformacionGlobal,
          meses: '',
        };
      }

      value = {
        ...value,
        InformacionGlobal: newInformacionGlobal,
      };
    }

    if (value.InformacionGlobal?.periodicidad !== '05') {
      let newInformacionGlobal = value.InformacionGlobal;

      const meses = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

      if (meses.indexOf(value.InformacionGlobal?.meses) === -1) {
        newInformacionGlobal = {
          ...value.InformacionGlobal,
          meses: '',
        };
      }

      value = {
        ...value,
        InformacionGlobal: newInformacionGlobal,
      };
    }

    let newMetadata = {
      ...Metadata,
    };

    if (!!value.Metadata) {
      newMetadata = {
        ...value.Metadata,
      };
    }

    if (value.Observaciones !== undefined) {
      newMetadata.Adicional = {
        ...newMetadata.Adicional,
        Observaciones: value.Observaciones,
      };
    }

    if (value.Decimales !== undefined) {
      newMetadata = {
        ...newMetadata,
        Decimales: value.Decimales,
      };
    }

    if (value.FormaPago) {
      const descripcion = FormaPagoCatalog.find((item) => item.value === value.FormaPago);

      newMetadata.FormaPagoDescripcion = descripcion.label;
    }

    if (!!value.CfdiFecha) {
      /** TODO Modificar el componente date-picker para que FormControl tome los cambios de los objetos Date  */
      // value = {
      //   ...value,
      //   CfdiFecha: value.CfdiFecha < moment().subtract(70, 'h').toDate()
      //     ? moment(value.CfdiFecha).add(1, 'hour').toDate()
      //     : moment(value.CfdiFecha).toDate()
      // };
    }

    const data = {
      ...this.props.create.data,
      ...value,
      Metadata: {
        ...newMetadata,
      },
    };

    const validator = this.validate(data);

    this.props.createActions.setPartialState({
      data,
      isValid: validator.passes(),
    });

    const { receptorManualInfo } = this.state;

    // Steps update
    let steps = { ...this.state.steps };

    steps.info =
      steps.info ||
      this.comprobante.isPago() ||
      this.comprobante.isTraslado() ||
      (!!data.FormaPago && !!data.MetodoPago);
    steps.cfdis_relacionados =
      steps.cfdis_relacionados ||
      this.comprobante.isPago() ||
      (!!data.CfdiRelacionados &&
        !!data.CfdiRelacionados.CfdiRelacionado &&
        !!data.CfdiRelacionados.CfdiRelacionado.length > 0);
    steps.emisor = steps.emisor || (!!data.Emisor && !!data.Emisor.rfc);
    steps.receptor = steps.receptor || (!!data.Receptor && !!data.Receptor.rfc);
    steps.conceptos =
      steps.conceptos ||
      this.comprobante.isNomina() ||
      this.comprobante.isPago() ||
      (!receptorManualInfo && !!data.Conceptos && !!data.Conceptos.Concepto && !!data.Conceptos.Concepto.length > 0);

    steps = {
      ...steps,
      ...newSteps,
    };

    this.setState({}, () => {
      setTimeout(() => {
        this.setState({
          ...this.state,
          validator,
          steps,
        });
      }, 100);
    });
  };

  handleOnFallbackChange = (event) => {
    const { name, checked } = event.target;

    this.onChange({
      [name]: checked,
    });
  };

  handleOnStartPointChange = (value) => {
    let steps = {
      bootstrap: true,
    };

    const query = qs.parse(this.props.location.search);

    if (!!query.u || !!query.p) {
      steps.cfdis_relacionados = true;
    }

    this.onChange(value, steps);
  };

  handleOnEmisorChange = (value) => {
    this.onChange(value, { emisor: true });
  };

  handleOnReceptorChange = (value) => {
    this.onChange(value, { receptor: true });
  };

  handleOnConceptosChange = (value) => {
    this.onChange(value, { conceptos: true });
  };

  handleOnSetComplemento = (complemento) => {
    this.setState({
      ...this.state,
      complemento,
    });
  };

  handleOnReceptorManualInputRequest = (value) => {
    this.setState({
      receptorManualInfo: value,
    });
  };

  handleOnTipoDeComprobanteChange = (type) => {
    this.comprobante = TipoComprobante.make(type);

    const {
      data,
      data: { Metadata = {} },
    } = this.props.create;

    const needsCfdiRelacionados = this.comprobante.isEgreso()
      ? true
      : !!Metadata.cfdis_relacionados && !!Metadata.cfdis_relacionados.CfdiRelacionado;

    let CfdiRelacionados = !!needsCfdiRelacionados ? data.CfdiRelacionados || {} : undefined;

    if (this.comprobante.isEgreso()) {
      CfdiRelacionados.TipoRelacion = '01';
    } else {
      CfdiRelacionados = undefined;
    }

    let formaPago = null;
    let metodoPago = null;

    if (this.comprobante.isPago()) {
      formaPago = '99';
      metodoPago = 'PPD';
    }

    if (this.comprobante.isNomina()) {
      formaPago = '99';
      metodoPago = 'PUE';
    }

    const newData = {
      TipoDeComprobante: type,
      FechaTemp: new Date(),
      FormaPago: formaPago || this.state.FormaPago || null,
      MetodoPago: metodoPago || this.state.MetodoPago || null,
      CfdiRelacionados: CfdiRelacionados,
      Metadata: {
        ...Metadata,
        cfdis_relacionados: needsCfdiRelacionados,
      },
    };

    this.setState(
      {
        ...this.state,
        steps: {
          ...this.state.steps,
          nomina: !this.comprobante.isNomina(),
        },
        Nomina: data.Nomina,
        complemento: this.comprobante.isPago() ? 'pago' : null,
      },
      () => {
        this.onChange(newData);
      }
    );
  };

  handleOnConfirm = (step, value = true) => {
    this.setState({
      ...this.state,
      steps: {
        ...this.state.steps,
        [step]: value,
      },
    });
  };

  handleOnNominaChange = (event) => {
    this.setState({
      ...this.state,
      Nomina: event.data,
      steps: {
        ...this.state.steps,
        nomina: event.isValid,
      },
    });
  };

  handleOnStampingRequest = () => {
    const {
      data,
      data: { Complemento = {} },
    } = this.props.create;

    const { Nomina } = this.state;

    let newData = {
      ...data,
    };

    if (this.comprobante.isNomina()) {
      newData.Complemento = {
        ...Complemento,
        Nomina,
      };
    }

    let input = new ComprobanteRequestInputTransformer().make(newData);

    const query = qs.parse(this.props.location.search);

    if (!!query.p) {
      input.Idx = query.p;
      input.Clasificacion = 14;
      input.Metadata.auto_idx = false;
    }

    this.props.createActions.create(input);
  };

  handleOnCancel = () => {
    this.props.history.replace('/app/comprobantes');
  };

  handleDownload = async (uuid) => {
    try {
      const params = {
        type: 'zip',
      };

      setTimeout(() => this.handleOnAction('success'), 500);

      const response = await Http.get(`${window.BONJOUR_URL}/api/comprobantes/${uuid}/download`, {
        params,
        responseType: 'blob',
      });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar tu comprobante',
      });
    }
  };

  handleOnAction = (action) => {
    if (action === 'reset') {
      this.props.createActions.setPartialState({ error: null });

      return;
    }

    if (action === 'success') {
      const { result } = this.props.create;

      this.props.listActions.setListData(result.data);
    }

    const query = qs.parse(this.props.location.search);

    setTimeout(() => {
      if (!!query.intro) {
        this.props.history.replace('/app/intro');
      } else {
        this.props.history.replace('/app/comprobantes');
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  handleOnComplementoAdd = (data) => {
    const { data: originalData } = this.props.create;
    const { Complemento = {} } = originalData;

    let newData = {
      ...originalData,
      Complemento: {
        ...Complemento,
        ...data,
      },
    };

    const validator = this.validate(newData);

    this.props.createActions.setPartialState({
      data: newData,
      isValid: validator.passes(),
    });
  };

  renderError = () => {
    const { error } = this.props.create;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result } = this.props.create;

    return (
      <div className="result-container">
        <ResponseResult
          title="Factura emitida"
          result={result}
          extra={
            <>
              <Button
                type="button"
                variant="secondary"
                className="mr-3"
                onClick={this.handleDownload.bind(this, result.data.uuid)}
              >
                Descargar
              </Button>

              <Button
                type="button"
                onClick={this.handleOnAction.bind(this, 'success')}
              >
                Continuar
              </Button>
            </>
          }
        />
      </div>
    );
  };

  handleVersionChange = (event) => {
    const { data } = this.props.create;
    const { checked } = event.target;

    this.onChange({
      Version: !!checked ? '4.0' : undefined,
      Exportacion: !checked ? undefined : data.Exportacion,
    });
  };

  render() {
    const { receptorManualInfo, showPagosForm, complemento, steps } = this.state;
    const { bootstrap, tipo, info, cfdis_relacionados, emisor, receptor, conceptos } = steps;
    const {
      data,
      data: { Metadata = {}, Receptor = {} },
      isValid,
      busy,
      result,
      error,
    } = this.props.create;

    const query = qs.parse(this.props.location.search);

    const isValidData = isValid && (!this.comprobante.isNomina() || steps.nomina);

    const isFacturaGlobal =
      Receptor?.razon_social?.toUpperCase() === 'PUBLICO EN GENERAL' && Receptor?.rfc === 'XAXX010101000';

    const isSectorPrimario = Metadata?.SectorPrimario;

    return (
      <div className="comprobantes-create">
        <PageHeader
          to="/app/comprobantes"
          text="Facturas"
        />

        {!!error && this.renderError()}

        {!!result && this.renderResult()}

        {!tipo && (
          <div className="pb-4">
            <div>
              <strong className="text-black text-upper">Tipo de comprobante</strong>
            </div>

            <div className="section pb-3">
              <Row className="mt-3">
                <Col>
                  <p>¿Qué tipo de comprobante necesitas generar?</p>
                  <ComprobanteSelectionToolbar
                    comprobante={this.comprobante}
                    onChange={this.handleOnTipoDeComprobanteChange}
                  />
                </Col>
              </Row>

              <div className="pt-2 pb-4">
                <strong>NOTA: </strong> Para emitir un <strong>CFDI 4.0</strong> es necesario que completes la
                información del código postal del receptor y su régimen fiscal. Adicional debes ingresar la razón social{' '}
                <strong>sin régimen capital</strong>.
                <br />
                <br />
                <div className="pl-2">
                  Ejemplo:
                  <br />
                  Razón Social: <span className="text-dark">MI RAZON SOCIAL S.A. DE C.V</span>
                  <br />
                  Debe usarse: <span className="text-dark">MI RAZON SOCIAL</span> (Omitir el: S.A. DE C.V)
                </div>
                <br />
              </div>

              <Button
                variant="secondary"
                disabled={this.comprobante.isUndefined()}
                onClick={this.handleOnConfirm.bind(this, 'tipo', true)}
              >
                Continuar
              </Button>
            </div>
          </div>
        )}

        {!bootstrap && !query.p && (
          <div className="pb-4">
            <div>
              <strong className="text-black text-upper">Datos iniciales</strong>
            </div>

            {!!tipo && (
              <Row className="mt-2 section">
                <Col>
                  <UsePreviousCfdiAsBaseInputForm
                    comprobante={this.comprobante}
                    simple={query.u !== undefined}
                    related={query.r}
                    uuid={query.u}
                    onChange={this.handleOnStartPointChange}
                  >
                    <Button
                      variant="secondary"
                      onClick={this.handleOnConfirm.bind(this, 'bootstrap')}
                    >
                      Continuar
                    </Button>
                  </UsePreviousCfdiAsBaseInputForm>
                </Col>
              </Row>
            )}
          </div>
        )}

        {!!query.p && !!tipo && (
          <div className="pb-4">
            <div>
              <strong className="text-black text-upper">Prefactura</strong>
            </div>

            <Row className="mt-2 section">
              <Col>
                <UsePrefacturaBaseInputForm
                  comprobante={this.comprobante}
                  prefactura={query.p}
                  onChange={this.handleOnStartPointChange}
                ></UsePrefacturaBaseInputForm>
              </Col>
            </Row>
          </div>
        )}

        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Datos generales</strong>
          </div>

          {!!bootstrap && !!tipo && !this.comprobante.isPago() && (
            <Row className="mt-3 section">
              <Col>
                <ComprobanteCreationGlobalInfo
                  data={data}
                  metadata={Metadata}
                  onChange={this.onChange}
                />
              </Col>
            </Row>
          )}

          {!!bootstrap && !!tipo && this.comprobante.isPago() && (
            <div className="pt-3 section">
              <ul className="unstyled-list pl-0">
                <li>
                  <strong>Tipo de comprobante: </strong> Pago.
                </li>
                <li>
                  <strong>Método de pago: </strong> Pago en parcialidades o diferido.
                </li>
                <li>
                  <strong>Forma de pago: </strong> Por definir.
                </li>
              </ul>
            </div>
          )}
        </div>

        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">CFDIs relacionados</strong>
          </div>

          {!!bootstrap && !!tipo && !!info && (
            <div className="section">
              <Row className="mt-2">
                <Col>
                  <CfdisRelacionadosManager
                    comprobante={this.comprobante}
                    data={data}
                    onChange={this.onChange}
                    metadata={Metadata}
                  />
                </Col>
              </Row>

              {!cfdis_relacionados && !this.comprobante.isEgreso() && (
                <Row>
                  <Col>
                    <p>Si no quieres agregar CFDIs relacionados haz click en el botón "Continuar"</p>
                    <Button
                      variant="secondary"
                      className="mr-2"
                      onClick={this.handleOnConfirm.bind(this, 'cfdis_relacionados')}
                    >
                      Continuar
                    </Button>
                  </Col>
                </Row>
              )}
            </div>
          )}
        </div>

        {Guardian.allows('sector_primario.access') && (
          <div className="pb-4">
            <div>
              <strong className="text-black text-upper">¿Esta factura es de sector primario?</strong>
            </div>

            {!!bootstrap && !!tipo && !!info && !!cfdis_relacionados && (
              <div className="mt-2 section">
                <ComprobantesCreateSectorPrimarioToggle
                  data={data}
                  onFormDataChange={this.handleOnSectorPrimarioChange}
                />
              </div>
            )}
          </div>
        )}

        <Row>
          <Col
            sm="12"
            md="6"
            className="pb-4"
          >
            <div>
              {!isSectorPrimario && <strong className="text-black text-upper">Emisor</strong>}

              {isSectorPrimario && <strong className="text-black text-upper">Productor</strong>}
            </div>

            {!!bootstrap && !!tipo && !!info && !!cfdis_relacionados && (
              <div className="mt-2 section">
                <EmisorSelection
                  autoFocus
                  data={data}
                  onFormDataChange={this.onChange}
                />
              </div>
            )}
          </Col>

          <Col
            sm="12"
            md="6"
            className={receptorManualInfo ? 'z-index-top' : 'pb-4'}
          >
            <div>
              {!isSectorPrimario && <strong className="text-black text-upper">Receptor</strong>}

              {isSectorPrimario && <strong className="text-black text-upper">Adquiriente</strong>}
            </div>

            {!!bootstrap && !!tipo && !!info && !!cfdis_relacionados && !!emisor && (
              <div className="mt-2 section">
                <ReceptorSelection
                  autoFocus
                  data={data}
                  datos_fiscales_requeridos={true}
                  onManualInfoRequest={this.handleOnReceptorManualInputRequest}
                  onFormDataChange={this.onChange}
                  isSectorPrimario={isSectorPrimario}
                />
              </div>
            )}
          </Col>
        </Row>

        <Row>
          <Col
            sm="12"
            md="12"
            className=""
          >
            {!!bootstrap && !!tipo && !!info && !!cfdis_relacionados && !!emisor && !!receptor && !!isFacturaGlobal && (
              <>
                <div>
                  <strong className="text-black text-upper">Información Global</strong>
                </div>
                <div className="mt-2 section">
                  <InformacionGlobal
                    autoFocus
                    data={data}
                    datos_fiscales_requeridos={true}
                    onManualInfoRequest={this.handleOnReceptorManualInputRequest}
                    onFormDataChange={this.onChange}
                  />
                </div>
              </>
            )}
          </Col>
        </Row>

        {!!receptorManualInfo && <Backdrop />}

        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Personalizar</strong>
          </div>

          {!!bootstrap && !!tipo && !!info && !!cfdis_relacionados && !!emisor && !!receptor && (
            <>
              <div className="section">
                <Row>
                  <Col
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                  >
                    <PersonalizarSerieFolioForm
                      data={data}
                      onChange={this.onChange}
                    />
                  </Col>

                  <Col
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                  >
                    <PersonalizarFechaEmision
                      data={data}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                  >
                    <PersonalizarDecimales
                      data={data}
                      onChange={this.onChange}
                    />
                  </Col>

                  <Col
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                  >
                    <PersonalizarObservaciones
                      data={data}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
              </div>
            </>
          )}
        </div>

        {!!bootstrap && !!tipo && !!info && !!cfdis_relacionados && !!emisor && !!receptor && (
          <>
            <PersonalizarSucursalForm
              data={data}
              onChange={this.onChange}
            />
          </>
        )}

        {(data?.Emisor?.sucursal?.codigo_postal ?? false) && Guardian.allows('representacion_impresa.access') && (
          <div className="pb-4">
            <div>
              <strong className="text-black text-upper">Representación impresa</strong>
            </div>

            <div className="section">
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                >
                  <PersonalizarPdf
                    data={data}
                    onChange={this.onChange}
                  />
                </Col>
              </Row>
            </div>
          </div>
        )}

        {this.comprobante.isPago() &&
          !!bootstrap &&
          !!tipo &&
          !!info &&
          !!cfdis_relacionados &&
          !!emisor &&
          !!receptor && (
            <div className="pb-4">
              <div>
                <strong className="text-upper text-black">Pagos</strong>
              </div>
              {!!bootstrap && !!tipo && !!info && !!cfdis_relacionados && !!emisor && !!receptor && (
                <ComprobantePago
                  data={data}
                  showForm={showPagosForm}
                  metadata={Metadata}
                  onChange={this.handleOnPagoChange}
                />
              )}
            </div>
          )}

        {this.comprobante.isNomina() &&
          !!bootstrap &&
          !!tipo &&
          !!info &&
          !!cfdis_relacionados &&
          !!emisor &&
          !!receptor &&
          !!conceptos && (
            <ComprobanteNomina
              input={data}
              data={data.Nomina}
              metadata={Metadata}
              onChange={this.handleOnNominaChange}
            />
          )}

        {!this.comprobante.isPago() && !this.comprobante.isNomina() && (
          <ComprobanteIngresoEgreso
            showConceptos={
              !!bootstrap && !!tipo && !!info && !!cfdis_relacionados && !!emisor && !!receptor && !receptorManualInfo
            }
            showComplementos={
              !!bootstrap && !!tipo && !!info && !!cfdis_relacionados && !!emisor && !!receptor && !!conceptos
            }
            data={data}
            metadata={Metadata}
            onChange={this.onChange}
            onSetComplemento={this.handleOnSetComplemento}
          />
        )}

        {/* Descomentar cuando salga una versioin superior 4.0 */}
        {/* {isValidData && !!Receptor && this.comprobante.isNomina() && (
          <Row className="z-index-top">
            <Col>
              <Form.Group controlId="fallback">
                <Form.Check
                  type="checkbox"
                  custom={true}
                  name="fallback"
                  label="Emitir como CFDI 3.3 si falla la emisión de CFDI 4.0 (Fallback)"
                  checked={data.fallback || false}
                  onChange={this.handleOnFallbackChange}
                />
              </Form.Group>
            </Col>
          </Row>
        )} */}

        {isValidData && !complemento && (
          <Row className="pb-5">
            <Col>
              <Button
                variant="secondary"
                className="mr-2"
                disabled={busy}
                onClick={this.handleOnCancel}
              >
                Cancelar
              </Button>

              <LoadingButton
                loading={busy}
                disabled={!isValidData || busy}
                onClick={this.handleOnStampingRequest}
              >
                {busy ? 'Procesando...' : 'Crear factura'}
              </LoadingButton>
            </Col>

            {Guardian.allows('prefacturas.access') && Guardian.allows('prefactura.crear') && (
              <Col className="text-right">
                <PrefacturaUpsert
                  isValidData={isValidData}
                  nomina={this.state.Nomina}
                  comprobante={this.props.create}
                  id={query.p}
                />
              </Col>
            )}
          </Row>
        )}
      </div>
    );
  }
}

const mapState = (store) => {
  return {
    list: store.app.comprobantes.list,
    create: store.app.comprobantes.create,
  };
};

const mapActions = (actions) => {
  return {
    listActions: actions.app.comprobantes.list,
    createActions: actions.app.comprobantes.create,
  };
};

export default connect(useStore, mapState, mapActions)(ComprobanteCreate);
